<template>
    <label :for="label">{{ label }}</label>
    <div class="p-inputgroup">
        <InputText maxlength = "255" v-if="type == types.INPUT_TEXT" v-model="inputVal" :placeholder="placeholder"  :disabled="true"/>
        <InputNumber v-else-if="type == types.NUMBER" v-model="inputVal" :placeholder="placeholder" :useGrouping="false" :suffix="suffix" :minFractionDigits="2" :maxFractionDigits="2"  :disabled="true"/>
        <Textarea v-else-if="type == types.LONG_INPUT_TEXT" v-model="inputVal" rows="4" :readonly="true"/>
    </div>
</template>

<script>
export default {
    name: 'TextInput',
    props: {
        label: {
            type: String,
        },
        placeholder: {
            type: String,
        },
        suffix: {
            type: String,
        },
        type: {
            type: String,
        },
        types: {
            type: Object,
        },
    },
    data() {
        return {
            inputVal: null,
        };
    },
};
</script>
